import React from "react";
import { Card, CardBody, Col } from "reactstrap";

export const PodiumSkeleton = ({ config }) => {
  return (
    <Col md="3" sm="12" className={`order-md-${config.order}`}>
      <Card
        className="border-0 shadow-lg overflow-hidden"
        style={{
          borderRadius: "24px",
          height: config.height,
        }}
      >
        <CardBody className="d-flex flex-column justify-content-center align-items-center p-4">
          {/* Icon Skeleton */}
          <div
            className="placeholder-glow mb-3"
            style={{
              width: 70,
              height: 70,
              borderRadius: "50%",
              backgroundColor: "#e9ecef",
            }}
          />

          {/* Badge Skeleton */}
          <div
            className="placeholder-glow mb-4"
            style={{
              width: 140,
              height: 32,
              borderRadius: 999,
              backgroundColor: "#e9ecef",
            }}
          />

          {/* Campo Skeleton */}
          <div
            className="placeholder-glow mb-3"
            style={{
              width: "70%",
              height: 28,
              borderRadius: 8,
              backgroundColor: "#e9ecef",
            }}
          />

          {/* Hora Skeleton */}
          <div
            className="placeholder-glow"
            style={{
              width: "40%",
              height: 20,
              borderRadius: 8,
              backgroundColor: "#e9ecef",
            }}
          />
        </CardBody>
      </Card>
    </Col>
  );
};
